module.exports = __webpack_public_path__ + "static/img/a.feb5624.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productCenter/a.png
// module id = toDi
// module chunks = 0